import React from 'react';
import PageTransition from '../components/PageTransition';
import './LegalPages.css';

function RefundPolicyPage() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Cancellation & Refund Policy</h1>

                <section className="legal-section">
                    <p>We understand that plans can change; however, due to the nature of spiritual services, the following rules apply:</p>
                </section>

                <section className="legal-section">
                    <h2>Cancellations</h2>
                    <p>You may cancel a booking up to 24 hours before the scheduled date of the Pooja/Archana. Once the ritual has been performed or offerings have been purchased, cancellations are not permitted.</p>
                </section>

                <section className="legal-section">
                    <h2>No Refunds</h2>
                    <ul>
                        <li>If a cancellation is made within the eligible window, a refund (minus processing fees) will be issued to the original payment method within 7-10 business days.</li>
                        <li>Refunds are not applicable for "No-shows" or if the Prasadam is returned due to an incorrect address provided by the user.</li>
                        <li>No returns are available once the Prasadam has been dispatched or once an Archana order has been placed.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>Service Failure</h2>
                    <p>In the rare event that we are unable to perform the service due to temple restrictions or internal issues, a 100% refund will be processed.</p>
                </section>
            </div>
        </div>
    );
}

export default PageTransition(RefundPolicyPage);
